import { Container } from "@mui/material";
import bgImage from "assets/images/bg-desktop.jpg";
import HomePageLayout from "layouts/components/HomePageLayout";
import MainSection from "layouts/reusable/MainSection";
import { homeMainContent } from "static/homepage/data";

export const TermsOfService = () => {

    const { topic, content, image } = homeMainContent
    return (
        <HomePageLayout
            bgColor={"inherit"}
            image={bgImage}
            pageName="Terms Of Service"
            coverHeight=""
            heroText=""
        >

            <Container>

                <MainSection topic={topic} content={content} image={image} />
            </Container>


        </HomePageLayout>
    );
}

